//常规风险
import { useState, useEffect, useRef } from 'react'
import { Table, Spin, Radio, Space, DatePicker, Button, message, Input, Select, Drawer, Form, Switch, InputNumber, theme } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { FilePptOutlined, } from '@ant-design/icons';
import { RiskDisposeList_Get, getAlarmDistanceInfo, setAlarmDistanceInfo } from "@/server/conventional_risks"; // 引入Ajax
// import 'antd/dist/antd.dark.css';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { async } from 'ailabel';


export default function FixedPointRisk () {
  const location = useLocation();
  let params = location.state;
  const token = localStorage.getItem('dock_token');
  const navigate = useNavigate()
  const {
    token: { colorText },
  } = theme.useToken(); //获取主题颜色
  /**
   * data
   * */
  const { RangePicker } = DatePicker;
  const [spinningLoading, _spinningLoading] = useState(false);
  const [total, _total] = useState(0);
  const [List, _List] = useState();
  const [searchList, setSearchList] = useState({
    title: params?.search?.title || '',//航线名称
    order: params?.search?.order || '',
    status: params?.search?.status || '',
    urlType: params?.search?.urlType || 1,
    type: params?.search?.type || 1,
    types: params?.search?.types || 1,//1:记录   2统计
    s_start_time: params?.search?.s_start_time || '',//开始-开始时间
    s_end_time: params?.search?.s_end_time || '',//开始-结束时间
    e_start_time: params?.search?.e_start_time || '',//结束-开始时间
    e_end_time: params?.search?.e_end_time || '',//结束-结束时间
    pending: params?.search?.pending || 0,//待处理   0全部 1有 2无
    current: params?.search?.current || 1,
    pageSize: params?.search?.pageSize || 10,
  });

  const [alarmDistance, setAlarmDistance] = useState({//警报距离
    isOpen: false,
    loading: false,
    isTrue: true,
    originalData: [],//原数据
  })

  const [countColumns, setCountColumns] = useState([])

  /* methods */
  // 巡检报告
  const getList = async (sift_data) => {
    _List([]);
    params = null
    _spinningLoading(true)
    const res = await RiskDisposeList_Get({
      access_token: localStorage.getItem('dock_token') || '',
      type: sift_data.urlType,
      types: sift_data.types,
      title: sift_data.title,
      order: sift_data.order,
      status: sift_data.status,
      page: sift_data.current,
      perpage: sift_data.pageSize,
      s_start_time: sift_data.s_start_time,
      s_end_time: sift_data.s_end_time,
      e_start_time: sift_data.e_start_time,
      e_end_time: sift_data.e_end_time,
      pending: sift_data.pending,
    });
    if (res.ret === 200) {
      let arr = []
      res.data?.items?.forEach((item, index) => {
        let ch = []
        let obj = {}
        if (item.c_list && item.c_list.length > 0) {
          item?.c_list.forEach((ele, idx) => {
            let list = {
              ...ele,
              numKey: `${index}_${idx}`
            }
            ch.push(list)
          })
          obj = {
            ...item,
            c_list: ch,
            numKey: index,
          }
          arr.push(obj)
        } else {
          arr.push({
            ...item,
            numKey: index,
          })
        }
      });
      // 统计表头拼装 ↓
      let colArr = [
        {
          title: '航线名称',
          dataIndex: 'pipe_name',
          render: (text, item, index) => {
            return (
              <div>
                {
                  text
                    ? <div>{text}</div>
                    : <div className='opa25'>-</div>
                }
              </div>
            );
          },
        },
        {
          title: '巡检开始时间',
          dataIndex: 'start_time',
          render: (text, item, index) => {
            return (
              <div>
                {
                  text
                    ? <div>
                      <span className='fSize14  opacity0_85 margR8'>{text.split(' ')[0]}</span>
                      <span className='fSize14  opacity0_45'>{text.split(' ')[1]}</span>
                    </div>
                    : <div className='opa25'>-</div>
                }
              </div>
            );
          },
        },
        {
          title: '巡检结束时间',
          dataIndex: 'end_time',
          render: (text, item, index) => {
            return (
              <div>
                {
                  text
                    ? <div>
                      <span className='fSize14  opacity0_85 margR8'>{text.split(' ')[0]}</span>
                      <span className='fSize14  opacity0_45'>{text.split(' ')[1]}</span>
                    </div>
                    : <div className='opa25'>-</div>
                }
              </div>
            );
          },
        },
      ]
      let colArrLast = [
        {
          title: '忽略',
          dataIndex: 'ignore_count',
          render: (text, item, index) => {
            return (
              <div>
                {
                  text
                    ? <div>{text}</div>
                    : <div className='opa25'>-</div>
                }
              </div>
            );
          },
        },
        {
          title: '分配',
          dataIndex: 'user_count',
          render: (text, item, index) => {
            return (
              <div>
                {
                  text
                    ? <div>{text}</div>
                    : <div className='opa25'>-</div>
                }
              </div>
            );
          },
        },
      ]
      res.data.sjzd.risk_type
        &&
        res.data.sjzd.risk_type.forEach((res) => {
          let list = {
            title: res.label,
            dataIndex: res.value,
            render: (text, item, index) => {
              return (
                <div>
                  {
                    text
                      ? (
                        <div>
                          <span
                            style={{ color: 'red' }}
                            className='pointer'
                            onClick={() => {
                              let obj = {
                                statid: item.id,
                                insIds: item.insIds,
                                total: item.pending_count,
                                transfer: searchList,
                                abnormal_type: res.value.split('_')[1]
                              }
                              navigate('/conventional_risks_handle', { state: obj })
                            }}
                          >
                            {text}
                          </span>
                        </div>
                      )
                      : (<div className='opa25'>-</div>)
                  }
                </div>
              );
            },
          }
          colArr.push(list)
        })

      colArrLast.forEach(e => {
        colArr.push(e)
      })

      setCountColumns([...colArr])
      // 统计表头拼装 ↑

      _List(arr || []);
      _total(res.data.total || 0)
    }
    _spinningLoading(false)
  };

  // 分页、排序、筛选变化时触发
  const handleTableChange = (newPagination, filters, sorter) => {
    let searchBefore = { ...searchList };
    // 分页
    searchBefore.current = newPagination.current;
    searchBefore.pageSize = newPagination.pageSize;
    setSearchList({ ...searchBefore })
    getList(searchBefore) //加载列表
  };

  // 记录表头
  const columns = [
    {
      title: '航线名称',
      dataIndex: 'routes_name',
    },
    {
      title: '巡检开始时间',
      dataIndex: 'start_time',
      render: (_, item, index) => {
        return (
          <div className='flex align_center' style={{ display: (item.start_time) ? 'block' : 'none' }}>
            <span className='fSize14 l opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
            <span className='fSize14 l opacity0_45'>{item.start_time.split(' ')[1]}</span>
          </div>
        );
      },
    },
    {
      title: '巡检结束时间',
      dataIndex: 'end_time',
      render: (_, item, index) => {
        return (
          <div className='' style={{ display: (item.end_time) ? 'block' : 'none' }}>
            <span className='fSize14 opacity0_85 margR8'>{item.end_time.split(' ')[0]}</span>
            <span className='fSize14 opacity0_45'>{item.end_time.split(' ')[1]}</span>
          </div>
        );
      },
    },
    {
      title: '风险点',
      dataIndex: 'risks_count',
      render: (text, item, index) => {
        return (
          <div className='curPointer margL6'>
            {text}
          </div>
        );
      },
    },
    {
      title: '待处理',
      dataIndex: 'pending_count',
      render: (text, item, index) => {
        return (
          <div className='margL6'>
            {
              Number(text) === 0
                ? <span>{text}</span>
                : (
                  <span
                    style={{ color: 'red' }}
                    className='pointer'
                    onClick={() => {
                      let obj = {
                        statid: item.id,
                        insIds: item.InsIDs,
                        total: item.pending_count,
                        transfer: searchList,
                        handler_status: 1,
                        is_handle: true,//涪陵功能
                      }

                      navigate('/conventional_risks_handle', { state: obj })

                    }}
                  >
                    {text}
                  </span>
                )
            }
          </div>
        );
      },
    },
    {
      title: '已处理',
      dataIndex: '',
      render: (_, item, index) => {
        return (
          <div>
            <div className='curPointer'>
              <div style={{ display: (item.risks_count > 0) ? 'block' : 'none' }}
                className="margL6 "
                onClick={
                  () => {
                    //如果待处理=风险点说明没有处理
                    if (item.pending_count === item.risks_count) {
                      return;
                    }
                    let obj = {
                      companyId: item.CompanyID,
                      statid: item.id,
                      insIds: item.InsIDs,
                      total: item.risks_count,
                      transfer: searchList,
                      handler_status: 2,
                      is_handle: false,//涪陵功能
                    }
                    navigate('/conventional_risks_handle', { state: obj })
                  }
                }>
                <span style={{ color: (Number(item.risks_count) - Number(item.pending_count) > 0) ? '#177ddc' : 'white' }}>
                  {Number(item.risks_count) - Number(item.pending_count)}
                </span>
              </div>
            </div>
          </div>
        );
      },
    }
  ];

  useEffect(() => {
    let sea = { ...searchList };
    // 根据url地址确定当前属于哪个类型的记录
    switch (location.pathname) {
      case '/routine_risk_conduit'://管道
        sea.urlType = 1;
        sea.type = 1
        break;
      case '/routine_risk_powerGrid'://电网
        sea.urlType = 7;
        sea.type = 1
        break;
      case '/fixedPoint_risk_electricTower'://电塔
        sea.urlType = 8;
        sea.type = 1
        break;
      case '/fixedPoint_risk_station'://场站
        sea.urlType = 9;
        sea.type = 1
        break;
      default:
        break;
    }
    if (params) {
      setSearchList({ ...params.search });
      getList(params.search);
    } else {
      setSearchList({ ...sea })
      getList(sea)
    }
    //eslint-disable-next-line
  }, [params, location.pathname])

  return (
    <div className="padd_24 flex-col tablebackcol" style={{ overflowY: 'auto' }}>
      <div className='padd_24 flex-auto backcol'>
        <div className='marB24 flex jcsb align_center'>
          <Radio.Group
            style={{ display: '' }}
            value={searchList.types}
            optionType="button"
            onChange={(e) => {
              let sea = searchList
              sea.types = e.target.value
              sea.current = 1
              setSearchList({ ...sea })
              getList(sea)
            }}
            options={[
              {
                label: '记录',
                value: 1,
              },
              {
                label: '统计',
                value: 2,
              },
            ]}
          />
          <div>
            <Space>
              <Input
                allowClear
                placeholder='航线名称'
                defaultValue={searchList.title}
                // value={searchList.title}
                onChange={(e) => {
                  let sea = searchList
                  sea.title = e.target.value
                  sea.current = 1
                  setSearchList({ ...sea })
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') { e.target.blur() } }}
                onBlur={() => {
                  getList(searchList)
                }}
              />

              <RangePicker
                locale={locale}
                showHour
                clearFilters
                value={searchList.s_start_time ? [dayjs(searchList.s_start_time, 'YYYY-MM-DD'), dayjs(searchList.s_end_time, 'YYYY-MM-DD')] : null}
                format="YYYY-MM-DD"
                placeholder={['巡检开始起', '巡检开始止']}
                onChange={(e) => {
                  let sea = searchList
                  if (e) {
                    sea.s_start_time = dayjs(e[0]).format('YYYY-MM-DD')
                    sea.s_end_time = dayjs(e[1]).format('YYYY-MM-DD')
                  } else {
                    sea.s_start_time = ''
                    sea.s_end_time = ''
                  }
                  sea.current = 1
                  setSearchList({ ...sea })
                  getList(sea)
                }}
              />

              <RangePicker
                locale={locale}
                showHour
                clearFilters
                value={searchList.e_start_time ? [dayjs(searchList.e_start_time, 'YYYY-MM-DD'), dayjs(searchList.e_end_time, 'YYYY-MM-DD')] : null}
                format="YYYY-MM-DD"
                placeholder={['巡检结束起', '巡检结束止']}
                onChange={(e) => {
                  let sea = searchList
                  if (e) {
                    sea.e_start_time = dayjs(e[0]).format('YYYY-MM-DD')
                    sea.e_end_time = dayjs(e[1]).format('YYYY-MM-DD')
                  } else {
                    sea.e_start_time = ''
                    sea.e_end_time = ''
                  }
                  sea.current = 1
                  setSearchList({ ...sea })
                  getList(sea)
                }}
              />

              <Select
                value={searchList.pending}

                style={{
                  display: searchList.types === 2 ? `none` : ``,
                  width: '126px'
                }}
                onChange={(e) => {
                  let sea = searchList
                  sea.pending = e
                  sea.current = 1
                  setSearchList({ ...sea })
                  getList(sea)
                }}
                options={[
                  {
                    value: 0,
                    label: '待处理：全部',
                  },
                  {
                    value: 1,
                    label: '待处理：有',
                  },
                  {
                    value: 2,
                    label: '待处理：无',
                  },
                ]}
              />
              <Button
                style={{ display: searchList.types === 2 && Number(localStorage.getItem('dock_memberLevel')) === 255 ? `` : `none`, }}
                icon={<FilePptOutlined />}
                onClick={() => {
                  window.open(`/api/admin.php?service=Admin.Airport.RiskDisposePicReport_Export&access_token=${token}&type=${searchList.urlType}&title=${searchList.title}&s_start_time=${searchList.s_start_time}&s_end_time=${searchList.s_end_time}&e_start_time=${searchList.e_start_time}&e_end_time=${searchList.e_end_time}`)
                }}
              >
                导出
              </Button>
            </Space>

          </div>
        </div>

        <Table
          columns={searchList.types === 1 ? columns : countColumns}
          rowKey='numKey'
          loading={spinningLoading}
          dataSource={List}
          pagination={
            searchList.types === 1
              ? {
                total: total,
                current: searchList.current,
                pageSize: searchList.pageSize,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                showQuickJumper: true,
                showSizeChanger: true,
              }
              : false
          }
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
}
